import { secretKey, sha256Salt } from "../contants";
import { aesEncrypt, sha256 } from "./cryptoUtils";
import { Request } from "../axios-config";
import { showConsoleError } from "../../util/ConsoleMessage";

export interface APIResponse<T> {
  ResponseCode: number;
  ResponseData: T;
  ResponseMsg: string;
}

export const enum ApiType {
  Local,
  Main, 
}

export const createEncryptedPayload = <T>(
  basePayload: T,
  hashPayload: string,
  apiType: ApiType
): string => {
  const salt = apiType == ApiType.Main ? sha256Salt : secretKey;
  const hash = computeHash(hashPayload, salt);
  const payload = { ...basePayload, Hash: hash };
  return aesEncrypt(payload, secretKey);
};

export const computeHash = (
  hashPayload: string,
  sha256Salt: string
): string => {
  const textToHash = hashPayload + sha256Salt;
  return sha256(textToHash);
};

export const apiPostRequest = async <T>(
  endpoint: string,
  payload: string
): Promise<APIResponse<T> | null> => {
  try {
    const response = await Request.post(endpoint, payload);
    return response.data as APIResponse<T>;
  } catch (error: any) {
    showConsoleError("Axios Error: ", error.data.error);
    return Promise.reject(error);
  }
};
